/*
 * @Author: 317473294@qq.com
 * @Date: 2023-05-24 10:27:20
 * @LastEditTime: 2024-03-09 11:58:24
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/api/loginLog.js
 */
//导入请求拦截与响应拦截，每次请求，都会经过请求拦截，请求结束会产生响应拦截，
import Axios from "../axios"

//获取日志
export function getLog(data){
    console.log(data)
    return Axios({
        method:"get",
        url:`/api/getLogList?page=${data.page}&limit=${data.limit}`,
        data:data
    })
}
//添加日志
export function addLog(data){
    console.log(data)
    return Axios({
        method:"put",
        url:"/api/addLog",
        data:data
    })
}

//更新日志
export function updataLog(data){
    return Axios({
        method:"patch",
        url:"/api/updataLog",
        data:data
    })
}
//删除日志
export function deleteLog(data){
    return Axios({
        method:"delete",
        url:"/api/deleteLog",
        data:data
    })
}
//模糊查询日志
export function vogueSearchLog(data){
    return Axios({
        method:"post",
        url:"/api/vogueSearchLog",
        data:data
    })
}





// WEBPACK FOOTER //
// ./src/api/loginLog.js